import { CourseContainerData } from '@yandex-int/k-common';
import b from 'b_';
import { Text } from 'platform-components';
import React from 'react';

import { CourseContainerBannerContainer } from '../../course-container-banner/course-container-banner.container';

import './course-container-list__container-banner.scss';

interface Props {
    courseContainer: CourseContainerData;
    previewOnly?: boolean;
}

export const ContainerBanner = ({ courseContainer, previewOnly }: Props) => {
    const containerYear = courseContainer.course_container_link?.study_year;

    return (
        <div className={b('course-container-list__banner')}>
            <CourseContainerBannerContainer courseContainer={courseContainer} previewOnly={previewOnly} />
            {containerYear && (
                <div className="course-container-banner-year">
                    <Text size={Text.SIZE.S}>{containerYear}</Text>
                </div>
            )}
        </div>
    );
};
